<template>
  <div class='hj-header'>
    <div class='companyName'><img src='../../assets/img/home/companyName.png' height='40'></div>
    <div class='header-menus header-height'>
      <div index='home' @click="handleSelect('index')" class="menus-row">
        <div :class="['menu-title',activeIndexFlag == 'index'?'is-active':'']"><span data-content="首页"></span>首页
        </div>
      </div>
      <div index='aboutUs' @click="handleSelect('aboutUs')" class="menus-row">
        <div :class="['menu-title',activeIndexFlag == 'aboutUs'?'is-active':'']"><span data-content="关于我们"></span>关于我们
        </div>
      </div>
      <div index='companyDevelopt' @click="handleSelect('companyDevelopt')" class="menus-row">
        <div :class="['menu-title',activeIndexFlag == 'companyDevelopt'?'is-active':'']"><span
          data-content="公司荣耀"></span>公司荣耀
        </div>
      </div>
      <div index='productIntroduction' @click="handleSelect('productIntroduction')" class="menus-row">
        <div :class="['menu-title',activeIndexFlag == 'productIntroduction'?'is-active':'']"><span
          data-content="产品介绍"></span>产品介绍
        </div>
      </div>
      <div index='usinessPartner' @click="handleSelect('usinessPartner')" class="menus-row">
        <div :class="['menu-title',activeIndexFlag == 'usinessPartner'?'is-active':'']"><span
          data-content="合作伙伴"></span>合作伙伴
        </div>
      </div>
      <div index='joinUs' @click="handleSelect('joinUs')" class="menus-row">
        <div :class="['menu-title',activeIndexFlag == 'joinUs'?'is-active':'']"><span data-content="联系我们"></span>联系我们
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "",
  props: {
    activeIndex: {
      type: String,
      default() {
        return 'home'
      }
    }
  },
  data() {
    return {
      activeIndexFlag: ''
    }
  },
  watch: {
    'activeIndex'() {
      this.activeIndexFlag = this.activeIndex
    }
  },
  mounted() {
    this.activeIndexFlag = this.activeIndex
  },
  methods: {
    handleSelect(key) {
      console.log(key);
      let path = `/mobile/` + key
      this.$router.push({path: path});
    }
  }
}
</script>

<style lang='scss' scoped>
.hj-header {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  display: flex;
  flex-direction: column;
  $topHeight: 40px;

  .companyName {
    margin-top: 10px;
    height: $topHeight;
    line-height: $topHeight;
    width: 100%;
    text-align: left;
  }

  .header-menus {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }

  .menus-row {
    flex: 1;
  }

  .is-active {
    color: #ff8e3e;
    border-bottom: 3px #ff8e3e solid !important;
  }

  .menu-title {
    position: relative;
    display: inline-block;
    font-size: 12px;
    overflow: hidden;
    padding: 10px 0 8px;
    border-bottom: 3px #ffffff solid;
    transition: all 1000ms ease;

    span {
      position: absolute;
      top: 0;
      left: 0;
      overflow: hidden;
      transform: translateX(-100%);
      transition: all 1000ms ease;
      padding: 10px 0 8px;
    }

    span::before {
      display: inline-block;
      content: attr(data-content);
      color: #ff8e3e;
      transform: translateX(100%);
      transition: all 1000ms ease;
    }
  }

  .menu-title:hover span {
    transform: translateX(0);
    color: #FFFFFF;
    transition: all 1000ms ease;
  }

  .menu-title:hover span::before {
    transform: translateX(0);
    color: #ff8e3e;
    transition: all 1000ms ease;
  }

  .menu-title:hover {
    transform: translateX(0);
    color: #FFFFFF;
    border-bottom: 3px #ff8e3e solid;
    transition: all 2000ms ease;
  }

  .menu-title::before {
    transform: translateX(0);
    color: #ff8e3e;
    border-bottom: 3px #FFFFFF solid;
    transition: all 1000ms ease;

  }
}
</style>
